import fetch from '@/utils/fetch'
// 创建公开(链接)分享、用户分享或群组分享
export function createShare (data) {
  return fetch({
    url: '/share/create',
    method: 'post',
    data
  })
}
// 获取已分享列表(创建人)
export function shareList (params) {
  return fetch({
    url: '/share/list',
    method: 'get',
    params:{
      share_type: params.share_type,
      tags: params.tags,
      search_name: params.search_name,
      offset: params.offset,
      limit: params.limit
    }
  })
}
// 获取分享给当前用户或用户所在群的分享列表(接收人)
export function shareUserList (params) {
  return fetch({
    url: '/share/user/list',
    method: 'get',
    params:{
      group_number: params.group_number,
      tags: params.tags,
      search_name: params.search_name,
      offset: params.offset,
      limit: params.limit
    }
  })
}
// 获取已分享详情（创建人）
export function shareInfo (params) {
  return fetch({
    url: '/share/info',
    method: 'get',
    params: {
      share_number: params.share_number
    }
  })
}
// 获取已分享详情（接收人）
export function shareTargetInfo (data) {
  return fetch({
    url: '/share/target/info',
    method: 'post',
    data
  })
}
// 取消分享（创建人）
export function deleteShare (data) {
  return fetch({
    url: '/share/delete',
    method: 'post',
    data
  })
}
// 移除分享（接收人）
export function removeShare (data) {
  return fetch({
    url: '/share/remove',
    method: 'post',
    data
  })
}
// 【分享】【编辑】
export function editShare (data) {
  return fetch({
    url: '/share/edit',
    method: 'post',
    data
  })
}
// 获取分享资源列表(创建人)
export function shareResourceList (params) {
  return fetch({
    url: '/share/resource/list',
    method: 'get',
    params
  })
}
// 获取分享资源列表(接收人)
export function shareTargetResourceList (data) {
  return fetch({
    url: '/share/target/resource/list',
    method: 'post',
    data
  })
}
// 【分享资源】【举报】
export function createShareReport (data) {
  return fetch({
    url: '/share/resource/report/create',
    method: 'post',
    data
  })
}
// 【分享资源】【下载】
export function shareDownload (data) {
  return fetch({
    url: '/share/download',
    method: 'post',
    data
  })
}
// 【分享资源】【保存至我的网盘】(需登录验证)
export function saveShareResource (data) {
  return fetch({
    url: '/share/saveResource',
    method: 'post',
    data
  })
}
// 【分享资源】【预览】
export function sharePreview (data) {
  return fetch({
    url: '/share/preview',
    method: 'post',
    data
  })
}

// 【分享资源】【详情】
export function shareResourceInfo (params) {
  return fetch({
    url: '/share/resource/info/' + params.share_number,
    method: 'get',
    params: {
      share_resource_number: params.share_resource_number
    }
  })
}
// 提交视频转码(分享)
export function shareFileTranstate (data) {
  return fetch({
    url: '/share/resource/tran',
    method: 'post',
    data
  })
}
// 获取视频文件的转码进度(分享)
export function shareTranstateStatus (data) {
  return fetch({
    url: '/share/resource/transtate/status',
    method: 'post',
    data
  })
}

/**
 * 发布相关
 */

// 创建/修改发布
export function link (data) {
  return fetch({
    url: '/link',
    method: 'post',
    data
  })
}
// 获取已发布列表
export function getLinkList (params) {
  return fetch({
    url: '/link/list',
    method: 'get',
    params:{
      group_number: params.group_number,
      search_name: params.search_name,
      offset: params.offset,
      limit: params.limit
    }
  })
}
// 删除已创建的发布
export function deleteLinks (data) {
  return fetch({
    url: '/link/delete',
    method: 'post',
    data
  })
}
// 获取发布详情
export function linkInfo (params) {
  return fetch({
    url: '/link/info',
    method: 'get',
    params:{
      link_number: params.link_number
    }
  })
}
// 获取发布的资源列表
export function linkResourceList (params) {
  return fetch({
    url: '/link/resource/list',
    method: 'get',
    params:{
      link_number: params.link_number,
      link_resource_number: params.link_resource_number,
      is_rec: params.is_rec
    }
  })
}
// 管理发布的资源
export function linkResource (data) {
  return fetch({
    url: '/link/resource',
    method: 'post',
    data
  })
}
// 获取资源链接
export function linkResourceInfo (data) {
  return fetch({
    url: '/link/resource/info',
    method: 'post',
    data
  })
}

// 睿客网提供访问页面

// 1.获取发布具有的策略
export function linkTargetConstraint (link_number) {
  return fetch({
    url: '/link/target/constraint',
    method: 'get',
    params: {
      link_number
    }
  })
}
// 2.获取发布详情
export function linkTargetInfo (data) {
  return fetch({
    url: '/link/target/info',
    method: 'post',
    data
  })
}
// 3.获取发布资源列表
export function linkTargetResourceList (data) {
  return fetch({
    url: '/link/target/resource/list',
    method: 'post',
    data
  })
}
// 4.下载发布资源
export function linkTargetDownload (data) {
  return fetch({
    url: '/link/target/download',
    method: 'post',
    data
  })
}
// 5.预览发布资源
export function linkTargetPreview (data) {
  return fetch({
    url: '/link/target/preview',
    method: 'post',
    data
  })
}